module.exports = __webpack_public_path__ + "img/container_bg.f2c0d924.png";